<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  name: "App",
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.nothing {
  width: 100%;
  margin: 0 auto;
  line-height: 50px;
  color: #999;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}
.el-table .warning-row {
  background: rgba(163, 230, 255, 12%);
}

.el-table .success-row {
  background: rgba(110, 209, 255, 22%);
}
.pagaination-tool {
  margin: 30px auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue